function curatedFirstHandle(value) {
  try {
    const url = new URL(value, window.location.origin);
    if (!['http:', 'https:'].includes(url.protocol)) return null;
    const match = url.pathname.match(/\/products\/([^/]+)\/?$/);
    return match ? decodeURIComponent(match[1]) : null;
  } catch {
    return null;
  }
}

function curatedFirstContext() {
  if (!/\/collections\/[^/]+\/?$/.test(window.location.pathname)) return null;
  const first = new URLSearchParams(window.location.search).get('first');
  if (!first || !curatedFirstHandle(first)) return null;
  const container = document.getElementById('ProductGridContainer');
  const grid = container?.querySelector('#product-grid');
  return grid ? { container, grid, first } : null;
}

let curatedFirstRequest;

let staticFeaturedRequest;

function staticFeaturedContext() {
  const params = new URLSearchParams(window.location.search);
  if (!params.has('devilry_feature') || params.has('first')) return null;
  const container = document.getElementById('ProductGridContainer');
  const grid = container?.querySelector('ul#product-grid');
  const allowed = ['664587141405', '660784709917', '627581649181'];
  if (!grid || !allowed.includes(container.dataset.devilryCollectionId)) return null;
  const values = params.getAll('devilry_feature');
  const handle = values[0] || '';
  const valid = values.length === 1 && handle.length <= 255 && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle);
  const browsing = params.has('sort_by') || params.has('constraint') ||
    !/\/collections\/(?:shop-devilry|all-tees|t-shirts)\/?$/.test(window.location.pathname) ||
    Array.from(params.keys()).some((key) => key.startsWith('filter.'));
  const page = Number(params.get('page') || 1);
  const limit = Number(params.get('devilry_last_page'));
  const endPage = Number.isInteger(limit) && limit > 0 &&
    limit === Number(container.dataset.devilryLastPage) - 1 && container.dataset.devilryLastItems === '1' ? limit : null;
  return { container, grid, params, handle, valid, browsing, page, endPage };
}

function staticFeaturedLinks(context, active) {
  context.container.querySelectorAll('.pagination a[href]').forEach((link) => {
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
    if (active && context.endPage && !context.browsing && Number(url.searchParams.get('page') || 1) > context.endPage) {
      link.closest('li')?.setAttribute('hidden', '');
      return;
    }
    context.params.forEach((value, key) => {
      if (!['page', 'section_id', 'devilry_feature'].includes(key)) url.searchParams.set(key, value);
    });
    if (active) url.searchParams.set('devilry_feature', context.handle);
    else url.searchParams.delete('devilry_feature');
    link.href = url.href;
  });
}

function applyStaticFeatured() {
  staticFeaturedRequest?.abort();
  const context = staticFeaturedContext();
  if (!context) return false;
  const { container, grid, handle, valid, browsing, page } = context;
  const reveal = (status) => {
    delete container.dataset.devilryFeaturePending;
    container.dataset.devilryFeatureStatus = status;
  };
  if (!valid || !Number.isInteger(page) || page < 1) {
    staticFeaturedLinks(context, false);
    reveal('fallback');
    return true;
  }
  if (browsing) {
    staticFeaturedLinks(context, true);
    reveal('browse');
    return true;
  }
  if (page === 1 && container.dataset.devilryFeatureDeadline && Date.now() > Number(container.dataset.devilryFeatureDeadline)) {
    staticFeaturedLinks(context, false);
    reveal('timeout');
    return true;
  }
  const target = Array.from(grid.children).find((item) => item.dataset.devilryProductHandle === handle);
  if (target) {
    if (target.dataset.devilryProductAvailable !== 'true') {
      staticFeaturedLinks(context, false);
      reveal('fallback');
      return true;
    }
    if (page === 1) {
      target.classList.add('scroll-trigger--cancel');
      grid.prepend(target);
    }
    else {
      target.remove();
      if (grid.children.length === 0) {
        const url = new URL(window.location.href);
        url.searchParams.set('page', page - 1);
        url.searchParams.set('devilry_last_page', page - 1);
        window.location.replace(url.href);
        return true;
      }
    }
    staticFeaturedLinks(context, true);
    reveal('active');
    return true;
  }
  if (page !== 1) {
    staticFeaturedLinks(context, true);
    reveal('active');
    return true;
  }
  const request = new AbortController();
  staticFeaturedRequest = request;
  container.dataset.devilryFeaturePending = 'true';
  const timer = setTimeout(() => {
    request.abort();
    if (staticFeaturedContext()?.grid === grid) {
      staticFeaturedLinks(context, false);
      reveal('timeout');
    }
  }, Math.max(1, Number(container.dataset.devilryFeatureDeadline || Date.now() + 2000) - Date.now()));
  (async () => {
    let active = false;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(root + 'products/' + encodeURIComponent(handle), window.location.origin);
      url.searchParams.set('section_id', 'curated-first-product-card');
      if (context.params.has('preview_theme_id')) url.searchParams.set('preview_theme_id', context.params.get('preview_theme_id'));
      const response = await fetch(url.href, { signal: request.signal });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const card = html.querySelector('#shopify-section-curated-first-product-card > li.grid__item');
      const current = staticFeaturedContext();
      if (request.signal.aborted || current?.grid !== grid || current.handle !== handle || current.browsing || current.page !== 1 || !grid.isConnected) return;
      if (!card || card.dataset.curatedFirstHandle !== handle || card.dataset.devilryProductAvailable !== 'true') return;
      const membership = JSON.parse(card.dataset.devilryCollectionIds || '[]').map(String);
      if (!membership.includes(container.dataset.devilryCollectionId)) return;
      const teeIdentities = ['t-shirt-gildan-5000', 't-shirt-gildan-64000', 'back-print-tshirt', 'embroidered-gildan-5000', 'embroidered-gildan-64000', 'T-Shirt', 'Embroidered T-Shirt', 'T-Shirt Back Print Gildan 5000'];
      if (teeIdentities.includes(card.dataset.devilryProductIdentity)) card.querySelector('.card')?.classList.add('card--collection-tee-zoom');
      const component = card.querySelector('product-component[view-event-payload]');
      if (component) {
        const payload = JSON.parse(component.getAttribute('view-event-payload'));
        payload.context = 'collection';
        component.setAttribute('view-event-payload', JSON.stringify(payload));
      }
      card.classList.add('scroll-trigger--cancel');
      card.dataset.devilryProductHandle = handle;
      grid.prepend(card);
      active = true;
    } catch {
    } finally {
      clearTimeout(timer);
      if (!request.signal.aborted && staticFeaturedContext()?.grid === grid) {
        staticFeaturedLinks(context, active);
        reveal(active ? 'active' : 'fallback');
      }
    }
  })();
  return true;
}

async function applyCuratedFirst() {
  if (applyStaticFeatured()) return;
  curatedFirstRequest?.abort();
  const context = curatedFirstContext();
  if (!context) return;
  const { container, grid, first } = context;
  const handle = curatedFirstHandle(first);
  const findTarget = () => Array.from(grid.children).find((item) =>
    item.matches('li.grid__item') &&
    Array.from(item.querySelectorAll('a[href]')).some((link) => curatedFirstHandle(link.href) === handle)
  );
  const target = findTarget();
  if (target && target !== grid.firstElementChild) grid.prepend(target);
  container.querySelectorAll('.pagination a[href]').forEach((link) => {
    const url = new URL(link.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
    url.searchParams.set('first', first);
    link.href = url.href;
  });
  if (target || !grid.matches('ul')) return;
  const request = new AbortController();
  curatedFirstRequest = request;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(root + 'products/' + encodeURIComponent(handle), window.location.origin);
    url.searchParams.set('section_id', 'curated-first-product-card');
    const response = await fetch(url.href, { signal: request.signal });
    if (!response.ok) return;
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const card = html.querySelector('#shopify-section-curated-first-product-card > li.grid__item');
    const current = curatedFirstContext();
    if (request.signal.aborted || current?.grid !== grid ||
        curatedFirstHandle(current.first) !== handle || !grid.isConnected) return;
    if (!card || card.dataset.curatedFirstHandle !== handle) return;
    const existing = findTarget();
    if (existing) {
      if (existing !== grid.firstElementChild) grid.prepend(existing);
      return;
    }
    card.classList.add('scroll-trigger--cancel');
    grid.prepend(card);
  } catch {
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (event) => {
      if (!facetForm.hasAttribute('data-devilry-sort')) this.debouncedOnSubmit(event);
    });
    if (facetForm.hasAttribute('data-devilry-sort')) {
      facetForm.addEventListener('submit', (event) => event.preventDefault());
      facetForm.addEventListener('change', (event) => {
        const params = new URLSearchParams(window.location.search);
        params.delete('page');
        params.delete('section_id');
        params.set('sort_by', event.target.value);
        FacetFiltersForm.renderPage(params.toString(), event);
      });
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.request?.abort();
    FacetFiltersForm.request = new AbortController();
    curatedFirstRequest?.abort();
    staticFeaturedRequest?.abort();
    const curatedFirst = updateURLHash && curatedFirstContext();
    if (curatedFirst) {
      const params = new URLSearchParams(searchParams);
      params.set('first', curatedFirst.first);
      searchParams = params.toString();
    }
    if (updateURLHash && !curatedFirst && staticFeaturedContext()) {
      const params = new URLSearchParams(searchParams);
      const current = new URLSearchParams(window.location.search);
      current.forEach((value, key) => {
        if (key === 'devilry_feature' || key === 'preview_theme_id' || key.startsWith('utm_') || ['fbclid', 'gclid', 'msclkid'].includes(key)) {
          if (!params.has(key)) params.set(key, value);
        }
      });
      searchParams = params.toString();
    }
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    const request = FacetFiltersForm.request;
    fetch(url, { signal: request.signal })
      .then((response) => response.text())
      .then((responseText) => {
        if (request.signal.aborted) return;
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      }).catch((error) => {
        if (error.name !== 'AbortError') window.location.assign(`${window.location.pathname}?${FacetFiltersForm.searchParamsPrev}`);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    applyCuratedFirst();
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer')?.bindEvents();
    const sort = document.getElementById('DevilrySortBy');
    const freshSort = html.getElementById('DevilrySortBy');
    if (sort && freshSort) {
      sort.innerHTML = freshSort.innerHTML;
      sort.value = freshSort.value;
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const params = new URLSearchParams(this.createSearchParams(event.target.closest('form')));
      const inlineSort = document.getElementById('DevilrySortBy');
      if (inlineSort) params.set('sort_by', inlineSort.value);
      this.onSubmitForm(params.toString(), event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      const params = new URLSearchParams(forms.join('&'));
      const inlineSort = document.getElementById('DevilrySortBy');
      if (isMobile && inlineSort) params.set('sort_by', inlineSort.value);
      this.onSubmitForm(params.toString(), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyCuratedFirst, { once: true });
} else {
  applyCuratedFirst();
}

